import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import { 
  smartDecimalNumberFormatter,
  getUserStatsObject,
  recordActivity,
  getUrlDetailsObj
} from "../../../../services/commonService";
import Chart from "../../../Chart";


const processFinancialData = (data, key) => {
  if (!data?.[key]) return [];

  const sortedData = data[key].sort((a, b) => Number(a.category) - Number(b.category));
  return sortedData.map(item => ({
    ...item,
    value: item.value == null ? null : smartDecimalNumberFormatter(item.value)
  }));
};

export default function BuKeyFinancials({ bu_unit ,data,loading,error}) {
  const { accountName } = useParams();
  const [financialsData, setFinancialsData] = useState({});
  const [graph, setGraph] = useState('revenue');

  const currentUrl = useLocation().pathname;
  const pageParsedData = useMemo(() => {
    const data = getUrlDetailsObj(useLocation, useParams);
    data.query_params = { tab: 'business' };
    return data;
  }, [useLocation, useParams]);


  useEffect(() => {
    setFinancialsData(data?.data || [])
  }, [ loading]);

  const handleGraphChange = useCallback((graphName) => {
    setGraph(graphName);
  }, []);

  const graphData = useMemo(() => ({
    revenue: processFinancialData(financialsData, 'total_revenue'),
    operating_income: processFinancialData(financialsData, 'operating_income'),
    total_assets: processFinancialData(financialsData, 'total_assets'),
    capital_expenditure: processFinancialData(financialsData, 'capital_expenditure')
  }), [financialsData]);

  const graphLabels = {
    revenue: "Revenue",
    operating_income: "Op. Income",
    total_assets: "Assets",
    capital_expenditure: "CapEx"
  };

  useEffect(() => {
    const userStat = getUserStatsObject(
      "Business Segments",
      "bu_key_financial_graph_set",
      `Page Source: ${accountName}, BU: ${bu_unit}, Key Financials Graph Tab: ${graphLabels[graph]}`,
      currentUrl
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);
  }, [graph, accountName, bu_unit, currentUrl, pageParsedData]);

  if (error) console.log(error)

  if (!loading && !data?.data) return null;
  
  if (!loading && !Object.entries(graphData).some(([key, data])=>data?.length>0)) return null;

  return (
    <div className='generic-take-space-child '>
      <div className="custom_card_block min-height-455">
         <div className="key_finance_wrapper">
          <div className="head_top">
            <h5 className="main_head">Key Financials (Last 5 Years $ Mn)</h5>               
          </div>
          <div className="graph_section">
            <div className="key_graph_tab">
              {Object.entries(graphData).map(([key, data]) => (
                data.length > 0 && !data.every(item => isNaN(Number(item.value))) && (
                  <span key={key} onClick={() => handleGraphChange(key)} className={`key_graph_btn ${graph === key ? 'active_tab_kf' : ''}`}>
                    {graphLabels[key]}
                  </span>
                )
              ))}
            </div>
            {graphData[graph]?.length > 0 && (
              <Chart financials_data={graphData[graph]} active_chart={`bu_${graph}`} />
            )}
          </div>
        </div>
      </div>
      </div>
  );
}